import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon } from '../../../../engage/components/Icon';
import styles from './Nav.module.scss';

class Nav extends Component {
  render() {
    return (
      <div className={styles.toolbarContainer}>
        <div>
          <a href="/login" title="Vormats" className={styles.logoContainer} aria-label="To login">
            <Icon src={'logo'} className={styles.iconLogo} />
          </a>
        </div>
      </div>
    );
  }
}

export default withRouter(Nav);
